import {useMutation, useQueryClient} from "@tanstack/react-query";
import {putMarkAsReadNotification} from "../../services/notifications/putMarkAsReadNotification";

const usePutMarkAsReadNotification = () => {
  const queryClient = useQueryClient();

  const {isLoading, isError, error, mutate} = useMutation({
    mutationFn: putMarkAsReadNotification,
    onSuccess: () => {
      queryClient.invalidateQueries(["listNotifications"]);
    },
  });

  return {
    markAsRead: mutate,
    isLoading,
    isError,
    error,
  };
};

export default usePutMarkAsReadNotification;
